(function () {
    const init = function (root) {
        root.querySelectorAll('[data-filter-form-field]').forEach(function (field, index) {
            const select = field.querySelector('SELECT');
            select.addEventListener('change', function () {
                const fields = root.querySelectorAll('[data-filter-form-field]');
                for (let i = index + 1; i < fields.length; i++) {
                    fields.item(i).parentNode.removeChild(fields.item(i));
                }
                root.querySelector('FORM').submit();
            });
        });
    };
    window.addEventListener('load', function () {
        document.querySelectorAll('[data-filter-form]').forEach(init)
    })
})();

